// extracted by mini-css-extract-plugin
module.exports = {"teamName":"_3TJXh9Y9B7urp+5N1iULLQ==","tableContainer":"yKuyIhAjxVkS44zTxx764A==","spectate":"axDI1HUMqa2hrTb5mP4+Vw=="};